module.exports = __webpack_public_path__ + "img/icon_mall_us.dd17d39c.svg";